export default "__VITE_ASSET__KSJjBMkM__"